
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    steps() {
      return this.list.reduce((carry, step, index) => {
        carry.push({ index: index + 1, ...step })

        if (this.isNotLast(index)) {
          carry.push({ type: 'divider' })
        }

        return carry
      }, [])
    },
  },

  methods: {
    /**
     * @description: Get step class.
     * @param {*}
     * @return {*}
     */
    stepClass(step) {
      return {
        'step-block': step.type !== 'divider',
        active: step.index <= this.current,
        'divider-block': step.type === 'divider',
      }
    },
    /**
     * @description: Check not list index.
     * @param {*}
     * @return {*}
     */
    isNotLast(index) {
      if (this.list.length - 1 === index) {
        return false
      }

      return true
    },
  },
}
